{
	"eyebrow": "Legal",
	"toc": "Table of contents",
	"last_updated": "Last updated",
	"nav": {
		"label": "Legal pages",
		"privacy": "Privacy Policy",
		"terms": "Terms & Conditions",
		"legal_notices": "Legal Notices"
	},
	"contact": {
		"title": "Questions about these terms?",
		"description": "Our team is happy to clarify anything in this document. Reach out and we'll get back to you shortly.",
		"cta": "Contact us"
	},
	"privacy": {
		"meta": {
			"title": "Privacy Policy — UpSquad",
			"description": "How UpSquad collects, uses and protects your personal data."
		},
		"title": "Privacy Policy",
		"updated": "Effective Date: March 8, 2023",
		"effective_date": "March 8, 2023"
	},
	"terms": {
		"meta": {
			"title": "Terms & Conditions — UpSquad",
			"description": "The terms governing your use of UpSquad."
		},
		"title": "Terms & Conditions",
		"updated": "Effective Date: March 8, 2023",
		"effective_date": "March 8, 2023"
	},
	"legal_notices": {
		"meta": {
			"title": "Legal Notices — UpSquad",
			"description": "Company information and legal notices for UpSquad, Inc."
		},
		"title": "Legal Notices",
		"updated": "UpSquad, Inc. · Memphis, TN"
	}
}
